<template>
  <div class="chart-container">
    <canvas ref="ctx" width="400" height="400"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js';
import 'chartjs-plugin-datalabels';

let shouldChange = null;
const handleChange = function() { //eslint-disable-line
  if (shouldChange) clearTimeout(shouldChange);
  shouldChange = setTimeout(() => {
    this.updateChart();
  }, 200);
};

export default {
  name: 'tchart',
  props: {
    type: {
      required: true,
    },
    options: {
      required: true,
    },
    labels: {
      required: true,
    },
    datasets: {
      required: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.updateChart();
  },
  watch: {
    labels: { handler: handleChange },
    datasets: { handler: handleChange, deep: true },
    options: { handler: handleChange, deep: true },
  },
  methods: {
    updateChart() {
      if (this.chart) this.chart.destroy();
      this.chart = new Chart(this.$refs.ctx, {
        type: this.type,
        data: {
          labels: [...this.labels],
          datasets: [...this.datasets],
        },
        options: this.options,
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.chart-container
  position relative
  width 100%
  height 100%
>>> .tooltip
  border 1px solid var(--v-primary-base)
  border-radius 4px
  padding 10px
  background white
  p
    margin 0
</style>
